import React from 'react'

const EntityEmpty = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.763 24.9296L26.9037 7.07038C26.9037 6.73213 26.7696 6.40769 26.5308 6.16816C26.2919 5.92864 25.9679 5.79358 25.6296 5.7926H16.7C16.3614 5.79358 16.037 5.92852 15.7975 6.16793C15.5581 6.40735 15.4232 6.73179 15.4222 7.07038V8.62964H6.49258C6.32527 8.62964 6.15959 8.66259 6.00502 8.72662C5.85044 8.79065 5.70998 8.8845 5.59168 9.00281C5.47337 9.12112 5.37952 9.26157 5.31549 9.41615C5.25146 9.57072 5.21851 9.7364 5.21851 9.90371V24.9296H2.66666V26.2074H29.3333V24.9296H26.763ZM19.2518 24.9296H6.49258V9.90371H15.4222V17.7H19.2518V24.9296ZM25.4889 24.9296H20.5259V17.7C20.533 17.5307 20.5053 17.3618 20.4444 17.2037C20.3457 16.9739 20.182 16.7778 19.9734 16.6397C19.7649 16.5015 19.5205 16.4272 19.2704 16.4259H16.7V7.07038H25.6296L25.4889 24.9296Z"
        fill="#AAAAAA"
      />
      <path
        d="M9.68148 20.6074H8.40741V21.8815H9.68148V20.6074Z"
        fill="#AAAAAA"
      />
      <path
        d="M9.68148 16.0704H8.40741V17.3445H9.68148V16.0704Z"
        fill="#AAAAAA"
      />
      <path
        d="M9.68148 11.8186H8.40741V13.0927H9.68148V11.8186Z"
        fill="#AAAAAA"
      />
      <path
        d="M13.5074 20.6074H12.2333V23.1593H13.5074V20.6074Z"
        fill="#AAAAAA"
      />
      <path
        d="M13.5074 16.0704H12.2333V17.3445H13.5074V16.0704Z"
        fill="#AAAAAA"
      />
      <path
        d="M13.5074 11.8186H12.2333V13.0927H13.5074V11.8186Z"
        fill="#AAAAAA"
      />
      <path
        d="M17.0296 20.6074H15.7556V21.8815H17.0296V20.6074Z"
        fill="#AAAAAA"
      />
      <path
        d="M22.4407 8.98523H23.7148V10.2593H22.4407V8.98523ZM22.4407 14.0852H23.7148V15.363H22.4407V14.0852ZM22.2 20.6075H23.4741V23.1593H22.2V20.6075ZM18.6148 8.98523H19.8889V10.2593H18.6148V8.98523ZM18.6148 14.0852H19.8889V15.363H18.6148V14.0852Z"
        fill="#AAAAAA"
      />
      <path
        d="M23.7148 14.0852H22.4407V15.3593H23.7148V14.0852Z"
        fill="#AAAAAA"
      />
      <path
        d="M23.7148 8.98523H22.4407V10.2593H23.7148V8.98523Z"
        fill="#AAAAAA"
      />
      <path
        d="M19.8889 14.0852H18.6148V15.3593H19.8889V14.0852Z"
        fill="#AAAAAA"
      />
      <path
        d="M19.8889 8.98523H18.6148V10.2593H19.8889V8.98523Z"
        fill="#AAAAAA"
      />
      <path
        d="M13.5074 11.8186H12.2333V13.0927H13.5074V11.8186Z"
        fill="#AAAAAA"
      />
      <path
        d="M13.5074 16.0704H12.2333V17.3445H13.5074V16.0704Z"
        fill="#AAAAAA"
      />
      <path
        d="M9.68148 16.0704H8.40741V17.3445H9.68148V16.0704Z"
        fill="#AAAAAA"
      />
      <path
        d="M13.5074 20.6074H12.2333V23.1593H13.5074V20.6074Z"
        fill="#AAAAAA"
      />
      <path
        d="M9.68148 11.8186H8.40741V13.0927H9.68148V11.8186Z"
        fill="#AAAAAA"
      />
      <path
        d="M9.68148 20.6074H8.40741V21.8815H9.68148V20.6074Z"
        fill="#AAAAAA"
      />
      <path
        d="M17.0296 20.6074H15.7556V21.8815H17.0296V20.6074Z"
        fill="#AAAAAA"
      />
      <path d="M23.4741 20.6074H22.2V23.1593H23.4741V20.6074Z" fill="#AAAAAA" />
    </svg>
  )
}

export default EntityEmpty
